import React, { Component } from "react";
import relationshipbanner from "views/know-us-more/img/banner.png";
import { connect } from "react-redux";

import ReferFriendPopup from "./ReferFriendPopup";
class Jobdetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isrefermodalopen: false,
      previewjob:{}
    };
  }
  async componentDidMount(){
    // this.props
    if(this.props.previewjob){
    this.setState({previewjob: await this.props.previewjob })
    }
  }
  bindimgSrc(val){
    try {
      return process.env.REACT_APP_IMAGE_BASE_MG + "" + this.props.previewjob.p_path
    } catch (error) {
      
    }

  }
  add_default_src(ev){
    ev.target.src = relationshipbanner
  }
  render() {
    return (
      <div>
        <ReferFriendPopup showRefer={this.state.isrefermodalopen} />
        <div className="relative h-full flex items-center">
          
            <img
              onError={this.add_default_src}
              src={
                this.bindimgSrc()
              }
              alt="relationshipbanner"
              className="w-full py-4 maxh-396px"
            />
          
          <div className="inside-textauto-center">
            <h1 className="font-bold fsize36 text-black w-3/5">
              {this.props.previewjob
                ? this.props.previewjob.p_title
                : ""}
            </h1>
            <h1 className="font-normal fsize18 text-black py-6 w-3/4 line-clamp-2">
              {this.props.previewjob
                ? this.props.previewjob.p_short_description
                : ""}
            </h1>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    previewjob: state.SinglePortfolio.home.PREVIEWJOB.Data?state.SinglePortfolio.home.PREVIEWJOB.Data[0]:"",
  };
};

export default connect(mapStateToProps)(Jobdetails);
